import React from "react";
import { NavLink } from "react-router-dom";

export default function Navbar(props) {
  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {props.usertypeid == 0 ? (
            <>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewcompany"
                  aria-expanded="false"
                >
                  <i className="flaticon-381-user"></i>
                  <span className="nav-text">Company</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addcompany">Add Company</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewcompany">View Company</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/CompanyUser"
                  aria-expanded="false"
                >
                  <i className="flaticon-381-user"></i>
                  <span className="nav-text">Company User</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addcompanyuser">Add Company User</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewcompanyuser">View Company User</NavLink>
                  </li>
                </ul>
              </li>

              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewshift"
                  aria-expanded="false"
                >
                  <i className="fas fa-people-arrows"></i>
                  <span className="nav-text">Shifts</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addshift">Add Shifts</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewshift">View Shifts</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewunit"
                  aria-expanded="false"
                >
                  <i className="flaticon-046-home"></i>
                  <span className="nav-text">Farm Units</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addunit">Add Units</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewunit">View Units</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-images"></i>
                  <span className="nav-text">Change Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : props.usertypeid == 1 ? ( 
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewbooking"
                  aria-expanded="false"
                >
                  <i className="far fa-calendar-check"></i>
                  <span className="nav-text">Booking</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addbooking">Add Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewbooking">View Booking</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-id-card"></i>
                  <span className="nav-text">Reports</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/AgentalBal">Agent Bal</NavLink>
                  </li>
                  <li>
                    <NavLink to="/reportBy-account-title">Account Status</NavLink>
                  </li>
                  <li>
                    <NavLink to="/BookingBalc">Booking Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/performance-report">Performance Report</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewuser"
                  aria-expanded="false"
                >
                  <i className="far fa-user"></i>
                  <span className="nav-text">User</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/adduser">Add User</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewuser">View User</NavLink>
                  </li>
                </ul>
              </li>
      

              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/addpayment"
                  aria-expanded="false"
                >
                  <i className="far fa-credit-card"></i>
                  <span className="nav-text">Payments</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addpayment">Add Payment</NavLink>
                  </li>
                </ul>
              </li>

              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/addpricing"
                  aria-expanded="false"
                >
                  <i className="fas fa-tags"></i>
                  <span className="nav-text">Pricing</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addpricing">Add Pricing</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewprice">View Pricing</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/method"
                  aria-expanded="false"
                >
                  <i className="fas fa-microchip"></i>
                  <span className="nav-text">Method</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/method">Add Method</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewMethod">View Method</NavLink>
                  </li>
                </ul>
              </li>

              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-user-lock"></i>
                  <span className="nav-text">Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change Password</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : props.usertypeid == 2 ? (
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewbooking"
                  aria-expanded="false"
                >
                  <i className="fas fa-calendar-alt"></i>
                  <span className="nav-text">Booking</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addbooking">Add Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewmybooking">View My Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewbooking">View Booking</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>{" "}
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-images"></i>
                  <span className="nav-text">Change Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : props.usertypeid == 3 ? (
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewbooking"
                  aria-expanded="false"
                >
                  <i className="fas fa-calendar-alt"></i>
                  <span className="nav-text">Booking</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addbooking">Add Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewbooking">View Booking</NavLink>
                  </li>
                </ul>
              </li>

              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>{" "}
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-images"></i>
                  <span className="nav-text">Change Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : props.usertypeid == 5 ? (
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewbooking"
                  aria-expanded="false"
                >
                  <i class="far fa-calendar-check"></i>
                  <span className="nav-text">Booking</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addbooking">Add Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewbooking">View Booking</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-id-card"></i>
                  <span className="nav-text">Reports</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/AgentalBal">Agent Bal</NavLink>
                  </li>
                  <li>
                    <NavLink to="/reportBy-account-title">Account Status</NavLink>
                  </li>
                  <li>
                    <NavLink to="/BookingBalc">Booking Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/performance-report">Performance Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/addpayment"
                  aria-expanded="false"
                >
                  <i class="far fa-credit-card"></i>
                  <span className="nav-text">Payments</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addpayment">Add Payment</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-images"></i>
                  <span className="nav-text">Change Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : props.usertypeid == 4 ? (
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>{" "}
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : (
            <>
              <li>
                <NavLink to="/" className="ai-icon" aria-expanded="false">
                  <i className="flaticon-025-dashboard"></i>
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>{" "}
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/viewbooking"
                  aria-expanded="false"
                >
                  <i className="fas fa-calendar-alt"></i>
                  <span className="nav-text">Booking</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/addbooking">Add Booking</NavLink>
                  </li>
                  <li>
                    <NavLink to="/viewbooking">View Booking</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/search"
                  aria-expanded="false"
                >
                  <i className="fas fa-search"></i>{" "}
                  <span className="nav-text">Search</span>
                </NavLink>
                <ul aria-expanded="false">
                  
                  <li>
                    <NavLink to="/SearchDates">Farm Availbility</NavLink>
                  </li>
                  
                  <li>
                    <NavLink to="/ByUser">By User</NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  className="has-arrow ai-icon"
                  to="/change"
                  aria-expanded="false"
                >
                  <i className="fas fa-images"></i>
                  <span className="nav-text">Change Password</span>
                </NavLink>
                <ul aria-expanded="false">
                  <li>
                    <NavLink to="/change">Change</NavLink>
                  </li>
                </ul>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
}
